// extracted by mini-css-extract-plugin
export var caption = "index-module--caption--Eiabn";
export var screenshot = "index-module--screenshot--2d570";
export var wrap = "index-module--wrap--n4oAi";
export var wrapBlack = "index-module--wrapBlack--JDhlt index-module--wrap--n4oAi";
export var wrapBlue = "index-module--wrapBlue--xs2ad index-module--wrap--n4oAi";
export var wrapGreen = "index-module--wrapGreen--ojyH1 index-module--wrap--n4oAi";